export default {
    agreement_print: "Razılığı çap et",
    agreement_template: "Razılaşma şablonu",
    agreements: "Razılaşmalar",
    are_you_sure_you_want_to_delete_template: "Şablonu silmək istədiyinizə əminsiniz?",
    bite_templates: "Dişlərin düzülüşü",
    choose_fields_for_autocomplete: "Avto-doldurma üçün lazım olan dəyərləri seçin:",
    complaints_templates: "Şikayətlər",
    consents: "Razılıqlar",
    contract_template: "Müqavilə şablonu",
    contracts: "Müqavilələr",
    development: "İnkişaf",
    development_templates: "İnkişaf",
    diseases: "Xəstəliklər",
    diseases_templates: "Xəstəliklər",
    document_template_word_file_note: "Word faylını şablon kimi əlavə edə bilərsiniz. Word faylında təqləri dollar işarəsi və mötərizə ilə qeyd etmək lazımdır və yalnız böyük hərflərdən istifadə olunmalıdır. Məsələn: ${FIO_CLIENT}.",
    epikriz_templates: "Epikriz",
    found_templates_with_diagnosis: "Diaqnoz ilə tapılan şablonlar",
    full_treatment_template: "Müalicə şablonu",
    general_template: "Şablon",
    generate: "Formalaşdır",
    generated: "Formalaşdırıldı",
    inspection_templates: "Müayinə",
    medication_templates: "Müalicə",
    not_generated: "Formalaşdırılmadı",
    objectively_templates: "Obyektiv",
    plan_treatment_template: "Müalicə planı şablonu",
    plansurvey: "Müayinə planı",
    plansurvey_templates: "Müayinə planı",
    recommendations_templates: "Tövsiyələr",
    refresh_status_in: "{vendor}-da statusu yeniləyin",
    research: "Tədqiqat məlumatları",
    research_templates: "Tədqiqat məlumatları",
    researches: "Tədqiqatlar",
    see_in_onlinecontract: "OnlineContract-də bax",
    see_in_trustme: "TrustMe-də bax",
    see_in_vendor: "{vendor}-də bax",
    sign_via_onlinecontract: "OnlineContract vasitəsilə imzala",
    sign_via_trustme: "TrustMe vasitəsilə imzala",
    sign_via_vendor: "{vendor} vasitəsilə imzala",
    signed: "İmzalandı",
    signed_via_onlinecontract: "OnlineContract vasitəsilə imzalandı",
    signed_via_trustme: "TrustMe vasitəsilə imzalandı",
    standard_diagnoses: "Standart diaqnozlar",
    subjectively_templates: "Subyektiv",
    teeth_medication: "Müalicə",
    teeth_plansurvey: "Müayinə planı",
    teeth_recommendations: "Tövsiyələr",
    templates_treatments_categories: "Müalicə şablonlarının kateqoriyaları",
    upload_signed: "İmzalanmış faylı yüklə",
    uploaded: "Yükləndi"
}
